import React from 'react'

export const google = ({ color = 'multi' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 0 533.5 544.3">
    <path
      fill={color === 'white' ? '#fff' : '#4285f4'}
      d="M533.5 278.4c0-18.5-1.5-37.1-4.7-55.3H272.1v104.8h147c-6.1 33.8-25.7 63.7-54.4 82.7v68h87.7c51.5-47.4 81.1-117.4 81.1-200.2z"></path>
    <path
      fill={color === 'white' ? '#fff' : '#34a853'}
      d="M272.1 544.3c73.4 0 135.3-24.1 180.4-65.7l-87.7-68c-24.4 16.6-55.9 26-92.6 26-71 0-131.2-47.9-152.8-112.3H28.9v70.1c46.2 91.9 140.3 149.9 243.2 149.9z"></path>
    <path
      fill={color === 'white' ? '#fff' : '#fbbc04'}
      d="M119.3 324.3c-11.4-33.8-11.4-70.4 0-104.2V150H28.9c-38.6 76.9-38.6 167.5 0 244.4l90.4-70.1z"></path>
    <path
      fill={color === 'white' ? '#fff' : '#ea4335'}
      d="M272.1 107.7c38.8-.6 76.3 14 104.4 40.8l77.7-77.7C405 24.6 339.7-.8 272.1 0 169.2 0 75.1 58 28.9 150l90.4 70.1c21.5-64.5 81.8-112.4 152.8-112.4z"></path>
  </svg>
)

export const googlemaps = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 0 92.3 132.3">
    <path fill="#1a73e8" d="M60.2 2.2C55.8.8 51 0 46.1 0 32 0 19.3 6.4 10.8 16.5l21.8 18.3L60.2 2.2z" />
    <path fill="#ea4335" d="M10.8 16.5C4.1 24.5 0 34.9 0 46.1c0 8.7 1.7 15.7 4.6 22l28-33.3-21.8-18.3z" />
    <path
      fill="#4285f4"
      d="M46.2 28.5c9.8 0 17.7 7.9 17.7 17.7 0 4.3-1.6 8.3-4.2 11.4 0 0 13.9-16.6 27.5-32.7-5.6-10.8-15.3-19-27-22.7L32.6 34.8c3.3-3.8 8.1-6.3 13.6-6.3"
    />
    <path
      fill="#fbbc04"
      d="M46.2 63.8c-9.8 0-17.7-7.9-17.7-17.7 0-4.3 1.5-8.3 4.1-11.3l-28 33.3c4.8 10.6 12.8 19.2 21 29.9l34.1-40.5c-3.3 3.9-8.1 6.3-13.5 6.3"
    />
    <path
      fill="#34a853"
      d="M59.1 109.2c15.4-24.1 33.3-35 33.3-63 0-7.7-1.9-14.9-5.2-21.3L25.6 98c2.6 3.4 5.3 7.3 7.9 11.3 9.4 14.5 6.8 23.1 12.8 23.1s3.4-8.7 12.8-23.2"
    />
  </svg>
)

export const trustmary = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="61" height="113" viewBox="0 0 61 113">
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(-80 -109)">
        <g transform="translate(80 109)">
          <path fill="#FAA61A" d="M0 70.6111769L0 113 61 81.3888231 61 39 0 70.6111769"></path>
          <path fill="#FFC905" d="M0 42.7537096L61 81 61 38.2462904 0 0 0 42.7537096"></path>
        </g>
      </g>
    </g>
  </svg>
)

export const facebook = ({ color = 'blue' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 0 16 16">
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g>
        <g>
          <path
            fill={color === 'white' ? '#fff' : '#1877F2'}
            d="M16 8a8 8 0 10-9.25 7.903v-5.59H4.719V8H6.75V6.237c0-2.005 1.194-3.112 3.022-3.112.875 0 1.79.156 1.79.156V5.25h-1.008c-.994 0-1.304.617-1.304 1.25V8h2.219l-.355 2.313H9.25v5.59A8.002 8.002 0 0016 8"></path>
          <path
            fill={color === 'white' ? '#1877F2' : '#fff'}
            d="M11.114 10.313L11.47 8H9.25V6.5c0-.633.31-1.25 1.304-1.25h1.008V3.281s-.915-.156-1.79-.156c-1.828 0-3.022 1.107-3.022 3.112V8H4.719v2.313H6.75v5.59a8.06 8.06 0 002.5 0v-5.59h1.864"></path>
        </g>
      </g>
    </g>
  </svg>
)

export const g2 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 0 1000 1000">
    <circle cx="500" cy="500" r="500" fill="#FF492D"></circle>
    <path
      fill="#fefefe"
      d="M716.4 383H631c2.3-13.4 10.6-20.9 27.4-29.4l15.7-8c28.1-14.4 43.1-30.7 43.1-57.3 0-16.7-6.5-29.9-19.4-39.4s-28.1-14.2-45.9-14.2a70.8 70.8 0 00-38.9 11.1c-11.7 7.2-20.4 16.5-25.8 28.1l24.7 24.8c9.6-19.4 23.5-28.9 41.8-28.9 15.5 0 25 8 25 19.1 0 9.3-4.6 17-22.4 26l-10.1 4.9c-21.9 11.1-37.1 23.8-45.9 38.2s-13.1 32.5-13.1 54.4v6h129.2zM705 459.2H563.6l-70.7 122.4h141.4L705 704.1l70.7-122.5L705 459.2z"></path>
    <path
      fill="#fefefe"
      d="M505.1 663.3c-90 0-163.3-73.3-163.3-163.3s73.3-163.3 163.3-163.3L561 219.8a286.4 286.4 0 00-55.9-5.5c-157.8 0-285.7 127.9-285.7 285.7s127.9 285.7 285.7 285.7a283.9 283.9 0 00168.2-54.8l-61.8-107.2a162.8 162.8 0 01-106.4 39.6z"></path>
  </svg>
)

export const capterra = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 0 65.08 66.28">
    <defs>
      <style>{`.cls-1{fill:none;}.cls-2{fill:#f3a949;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#46c1ed;}.cls-5{clip-path:url(#clip-path-2);}.cls-6{fill:#006d9a;}.cls-7{fill:#de6a64;}`}</style>
      <clipPath id="clip-path" transform="translate(0 0)">
        <rect className="cls-1" x="44" width="22" height="66.28" />
      </clipPath>
      <clipPath id="clip-path-2" transform="translate(0 0)">
        <rect className="cls-1" x="27" y="24" width="18" height="42.28" />
      </clipPath>
    </defs>
    <g id="Ebene_2" data-name="Ebene 2">
      <g id="Ebene_1-2" data-name="Ebene 1">
        <g id="surface1">
          <path className="cls-2" d="M0,24.37H44.2V7.82L0,24.37" transform="translate(0 0)" />
          <g className="cls-3">
            <path className="cls-4" d="M44.2,7.82V66.28L65.08,0Z" transform="translate(0 0)" />
          </g>
          <g className="cls-5">
            <path className="cls-6" d="M44.2,24.38H27.49L44.2,66.28Z" transform="translate(0 0)" />
          </g>
          <path className="cls-7" d="M0,24.37,31.77,35.13,27.49,24.38Z" transform="translate(0 0)" />
        </g>
      </g>
    </g>
  </svg>
)

export const tripadvisor = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 0 1333.31 1333.31">
    <g fillRule="nonzero">
      <circle cx="666.66" cy="666.66" r="666.66" fill="#34e0a1"></circle>
      <path d="M1078.42 536.6l80.45-87.52h-178.4c-89.31-61.01-197.17-96.54-313.81-96.54-116.5 0-224.06 35.61-313.22 96.54H174.6l80.44 87.52c-49.31 44.99-80.22 109.8-80.22 181.75 0 135.79 110.09 245.88 245.88 245.88 64.51 0 123.27-24.88 167.14-65.55l78.81 85.81 78.81-85.73c43.87 40.67 102.57 65.47 167.07 65.47 135.79 0 246.03-110.09 246.03-245.88.07-72.03-30.84-136.83-80.15-181.75zM420.77 884.75c-91.92 0-166.4-74.48-166.4-166.4s74.49-166.4 166.4-166.4c91.92 0 166.4 74.49 166.4 166.4 0 91.91-74.49 166.4-166.4 166.4zm245.96-171.24c0-109.5-79.63-203.5-184.73-243.65 56.84-23.76 119.18-36.94 184.66-36.94 65.47 0 127.89 13.18 184.73 36.94-105.02 40.23-184.65 134.15-184.65 243.65zm245.88 171.24c-91.92 0-166.4-74.48-166.4-166.4s74.49-166.4 166.4-166.4c91.92 0 166.4 74.49 166.4 166.4 0 91.91-74.49 166.4-166.4 166.4zm0-253.7c-48.2 0-87.23 39.03-87.23 87.23 0 48.19 39.03 87.22 87.23 87.22 48.19 0 87.22-39.03 87.22-87.22 0-48.12-39.03-87.23-87.22-87.23zM508 718.35c0 48.19-39.03 87.22-87.23 87.22-48.19 0-87.22-39.03-87.22-87.22 0-48.2 39.03-87.23 87.22-87.23 48.19-.07 87.23 39.03 87.23 87.23z"></path>
    </g>
  </svg>
)

export const yelp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 0 15.9 27">
    <style>{`.st0{fill:#ff1a1a}`}</style>
    <g id="Layer_2_1_">
      <g id="Layer_1-2">
        <path
          className="st0"
          d="M5.2 16.1l.9-.2h.1c.3-.1.5-.2.6-.5.1-.2.2-.4.1-.7 0-.1-.1-.2-.2-.3-.1-.1-.2-.2-.4-.3-.2-.1-.3-.2-.5-.2l-1-.4-1.7-.6c-.4-.1-.7-.2-1-.3H2c-.2-.1-.5-.1-.8-.1-.1 0-.3 0-.4.1-.1 0-.2.1-.3.1 0 .1-.1.1-.1.2s-.1.1-.1.2l-.1.2c-.1.3-.2.9-.2 1.5s.1 1.2.3 1.7l.3.3c.2.1.4.2.6.2.3 0 .7 0 1-.1l3-.8zM15.4 11.2c-.3-.5-.6-1-1-1.4l-.2-.1-.2-.2h-.2c-.1-.1-.3-.1-.4-.1-.1 0-.3 0-.4.1-.2.1-.4.3-.6.5l-.1.1-.7.7-1.3 1.2-.7.8-.4.4c-.1.1-.2.3-.2.5v.4c.1.5.6.9 1.2.8h.1l4-.9.9-.3c.2-.1.4-.2.5-.4.1-.1.1-.3.1-.4.1-.6-.1-1.2-.4-1.7zM8.3 12.9c.2-.4.3-.9.3-1.4.1-1.5.2-2.9.2-4.4 0-.5.1-1.1.1-1.6s-.1-1-.3-1.4c-.5-.7-1.6-.6-2.4-.5l-.6.1-.7.2c-.7.2-1.7.7-1.9 1.5 0 .5.1 1 .3 1.4.2.5.5 1 .8 1.5l2.1 3.9c.2.4.5.8.9 1.1h.1c.2.1.4.1.6 0 .1-.2.3-.2.5-.4zM8 16.9c-.1-.2-.3-.3-.5-.4-.2-.1-.4-.1-.5 0h-.1c-.1 0-.1.1-.2.1-.2.1-.3.3-.4.5l-.1.1-.6.9c-.4.5-.7 1-1.1 1.5-.2.3-.4.6-.6.8l-.1.1c-.2.2-.3.4-.3.7v.4c0 .1.1.3.1.4 0 .1.1.1.1.2l.1.1.2.2c.4.3.9.5 1.4.7.4.1.9.2 1.3.2h.5c.1 0 .1 0 .2-.1.1 0 .2-.1.3-.2.1-.1.2-.2.2-.3.1-.2.1-.5.1-.7v-.2c0-.3 0-.6.1-1 0-.6.1-1.2.1-1.8V18c0-.3 0-.5-.1-.8 0-.1-.1-.2-.1-.3zM15.2 18.6c-.2-.2-.4-.3-.6-.5l-.2-.1c-.2-.1-.5-.3-.9-.5l-1.6-.9-1-.5-.1-.1c-.2-.1-.4-.2-.6-.2H9.9c-.2 0-.4.1-.5.3-.1.1-.2.3-.2.5v.4c.1.3.1.5.3.7l.5 1c.3.5.6 1.1.9 1.6.2.4.4.6.5.9l.1.1c.1.2.3.4.5.6.1.1.2.2.3.2.1 0 .3.1.4 0h.2c.1 0 .1 0 .2-.1l.2-.1c.4-.2.7-.5 1.1-.8.4-.4.7-.8 1-1.3l.1-.2.1-.2v-.2c0-.1 0-.3-.1-.4-.2.1-.3-.1-.3-.2z"
        />
      </g>
    </g>
  </svg>
)

export const googleplay = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 0 28.99 31.99">
    <g data-name="Capa 2">
      <g data-name="Capa 1">
        <path d="M13.54 15.28.12 29.34a3.66 3.66 0 0 0 5.33 2.16l15.1-8.6Z" style={{ fill: '#ea4335' }} />
        <path
          d="m27.11 12.89-6.53-3.74-7.35 6.45 7.38 7.28 6.48-3.7a3.54 3.54 0 0 0 1.5-4.79 3.62 3.62 0 0 0-1.5-1.5z"
          style={{ fill: '#fbbc04' }}
        />
        <path d="M.12 2.66a3.57 3.57 0 0 0-.12.92v24.84a3.57 3.57 0 0 0 .12.92L14 15.64Z" style={{ fill: '#4285f4' }} />
        <path
          d="m13.64 16 6.94-6.85L5.5.51A3.73 3.73 0 0 0 3.63 0 3.64 3.64 0 0 0 .12 2.65Z"
          style={{ fill: '#34a853' }}
        />
      </g>
    </g>
  </svg>
)
